import React, { Component } from 'react'
import { Menu } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

export default class AdminMenu extends Component {
  render() {
    return (
      <Menu vertical fluid>
        <Menu.Item>
          <Menu.Header>General</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              as={NavLink}
              to="/admin/dashboard"
              activeClassName="active"
            >
              Dashboard
            </Menu.Item>
          </Menu.Menu>
        </Menu.Item>
        <Menu.Item>
          <Menu.Header>Users</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              as={NavLink}
              to="/admin/create-user"
              activeClassName="active"
            >
              Create User
            </Menu.Item>
            <Menu.Item
              as={NavLink}
              to="/admin/manage-users"
              activeClassName="active"
            >
              Manage Users
            </Menu.Item>
          </Menu.Menu>
        </Menu.Item>
        <Menu.Item>
          <Menu.Header>Orders</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              as={NavLink}
              to="/admin/manage-orders"
              activeClassName="active"
            >
              Manage Orders
            </Menu.Item>
          </Menu.Menu>
        </Menu.Item>
        <Menu.Item>
          <Menu.Header>Products</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              as={NavLink}
              to="/admin/create-product"
              activeClassName="active"
            >
              Create Product
            </Menu.Item>
            <Menu.Item
              as={NavLink}
              to="/admin/manage-products"
              activeClassName="active"
            >
              Manage Products
            </Menu.Item>
            <Menu.Item
              as={NavLink}
              to="/admin/manage-categories"
              activeClassName="active"
            >
              Manage Categories
            </Menu.Item>
            <Menu.Item
              as={NavLink}
              to="/admin/manage-size-guide"
              activeClassName="active"
            >
              Manage Size Guide
            </Menu.Item>
          </Menu.Menu>
        </Menu.Item>
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminMenu.jsx